"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpointService = exports.BreakpointService = void 0;
var models_1 = require("../models");
/**
 * Utility service for listening for changes in breakpoint and managing Responsive<T> objects.
 */
var BreakpointService = /** @class */ (function () {
    function BreakpointService() {
        var _this = this;
        this.dispatcher = new models_1.SimpleDispatcher();
        this.started = false;
        this.mediaQueries = [];
        // PUBLIC METHODS ------------------------------------------------
        /**
         * Register a listener for breakpoint changes. Will kick off the media query subscription if needed.
         * @prop listener - function that takes a breakpoint, will fire when breakpoint changes
         * @returns a string key that you can use to unregister the listener
         */
        this.registerListener = function (listener) {
            if (!_this.started) {
                _this.start();
            }
            var result = _this.dispatcher.registerListener(listener);
            listener(_this.currentBreakpoint);
            return result;
        };
        // PRIVATE METHODS ------------------------------------------------
        this.start = function () {
            models_1.breakpointMetadata
                // generate media query strings
                .map(function (bpmd) {
                return "(min-width: " + bpmd.min_inclusive + "px) and (max-width: " + (bpmd.max_exclusive - 1) + "px)";
            })
                // wire up handlers
                .forEach(function (query, index) {
                var mediaQueryList = window.matchMedia(query);
                var listener = function (ql) {
                    if (ql.matches &&
                        _this.currentBreakpoint !== models_1.breakpointMetadata[index].name) {
                        _this.currentBreakpoint = models_1.breakpointMetadata[index].name;
                        _this.dispatcher.dispatch(_this.currentBreakpoint);
                    }
                };
                _this.mediaQueries.push({ mediaQueryList: mediaQueryList, listener: listener });
                mediaQueryList.addListener(listener);
                listener(mediaQueryList);
            });
            _this.started = true;
            return true;
        };
    }
    return BreakpointService;
}());
exports.BreakpointService = BreakpointService;
exports.breakpointService = new BreakpointService();
